import * as React from "react";
import * as ReactDOM from "react-dom";
import { vars, css, classNames } from "@src/services/theme";

interface Props {
  className?: string;
  open?: boolean;
  toggler?: string;
  title?: string;
  footer?: any;
  backdrop?: boolean;
  onOpen?: Function;
  onClose?: Function;
}

interface State {
  open: boolean;
}

const style = css`
    .errors {
        color: ${vars.colors.red};
    }
`;

export default class Modal extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open || false
    };
  }

  toggle() {
    const { onOpen, onClose } = this.props;
    const newOpen = !this.state.open;
    this.setState({
      open: newOpen
    });
    if (newOpen && onOpen) {
      onOpen();
    }
    if (!newOpen && onClose) {
      onClose();
    }
  }

  render() {
    const { children, className, toggler, title, footer, backdrop } = this.props;
    const { open } = this.state;

    return (
      <>
        {open && (
          <ModalComponent
            className={classNames(style, className)}
          >
            <div className="modal-backdrop fade in" />
            <div
              className="modal"
              style={{ display: "block" }}
              onClick={e => {
                if (backdrop && (e.target as any).className === "modal") {
                  this.toggle();
                }
              }}
            >
              <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" onClick={() => this.toggle()}><span aria-hidden="true">&times;</span></button>
                        <h4 className="modal-title">
                        {title || "-"}
                        </h4>
                    </div>
                    <div className="modal-body">{children}</div>
                </div>
                {footer && (
                  <div className="modal-footer">
                  {footer()}
                  </div>
                )}
              </div>
            </div>
          </ModalComponent>
        )}
        {toggler && (
          <span
            onClick={() => this.toggle()}
            dangerouslySetInnerHTML={{ __html: toggler }}
          />
        )}
      </>
    );
  }
}

const modalRoot = document.getElementsByTagName("body")[0];
const modalClass = "modal-open";
class ModalComponent extends React.Component<any> {
  private el;
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
    this.el.className = "UI_Modal " + props.className;
  }

  componentDidMount() {
    modalRoot.className += " " + modalClass;
    modalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    modalRoot.className = modalRoot.className.replace(modalClass, "");
    modalRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}



// WEBPACK FOOTER //
// ./src/components/UI/Modal.tsx